import { Routes } from '@angular/router';

export const chatConversationRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./chat-conversation.page').then((m) => m.ChatConversationPage),
  },
];
